import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c30119a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "info mb-6 mt-4" }

import Modal from '@/popup/components/shared/Modal/Modal'
import Button from '@/popup/components/shared/Button.vue'
import Sanitize from '@/popup/components/shared/Sanitize.vue'

type Emits = {
  (event: 'on-close'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionChangeConfirmation',
  emits: ["on-close"],
  setup(__props, { emit: __emit }) {

const emits = __emit

const onConfirm = () => {
  emits('on-close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, {
    class: "wrapper p-6",
    "data-testid": "modal-info"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, { class: "darker blurry" }),
      _createVNode(_unref(Modal).Content, { class: "wider" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('app.controller_permissions.important')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Sanitize, {
              html: _ctx.$t('app.controller_permissions.important_message')
            }, null, 8 /* PROPS */, ["html"])
          ]),
          _createVNode(Button, {
            variant: "primary",
            "is-full-width": true,
            onClick: onConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('import_waiting.confirm')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})